import { render } from "./PasswordForgotView.vue?vue&type=template&id=04046908&ts=true"
import script from "./PasswordForgotView.vue?vue&type=script&lang=ts"
export * from "./PasswordForgotView.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__